module.exports = "https://www.gc-qa.gnp.com.mx/4310b5c5de9f725fd1e99bce9de11860.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-twitter.svg
// module id = 1842
// module chunks = 0